import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { EntityProps } from 'client/types'
import React, { memo } from 'react'
import { BaseEditorButton } from 'src/editor/shared/entities/base-editor-button'
import { ButtonEntityInterface } from 'src/shared/entities/button/button.schema'

const ButtonNew = ({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<ButtonEntityInterface>) => {
  return (
    <BaseEntityNew
      entity={entity}
      flex
      flexColumn
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <BaseEditorButton entityOrSubEntity={entity} />
    </BaseEntityNew>
  )
}

export default memo(ButtonNew)
